import { createContext, useContext, useState } from 'react';

type TAppState<T = any> =
    T extends Record<string, any> ? T : Record<string, unknown>;

const AppStateContext = createContext<TAppState | undefined>(undefined);

export function useAppState<T = Record<string, unknown>>():
    | TAppState<T>
    | undefined {
    const state = useContext(AppStateContext);
    return state as TAppState<T> | undefined;
}

type TAppStateProviderProps = {
    children: React.ReactNode;
    state?: TAppState;
};

export const AppStateContextProvider = ({
    children,
    state,
}: TAppStateProviderProps) => {
    const [value] = useState<TAppState | undefined>(state);
    return (
        <AppStateContext.Provider value={value}>
            {children}
        </AppStateContext.Provider>
    );
};
